<div class="launcher-panel" [style.--header-panel-height]="headerHeight">
  <span class="launcher-panel__title">{{ 'header.app-launcher' | translate }}</span>

  @if (loading()) {
    <kds-spinner size="large" variant="absolute" />
  } @else {
    <div class="launcher-panel__modules">
      @for (module of modules(); track module.moduleId; let index = $index; let odd = $odd) {
        <itc-launcher-item [isTooltipRightAligned]="odd" [module]="module" />
      }
    </div>
  }
</div>
